import { uomOptions } from "../../../Components/Customers/constants/constantFunctionsView"
import { editGrantsAndChargesFunction, editGrantsAndChargesRecurringFunction } from "../../../Components/Pricings/Offers/constants/GrantsAndRecurringFunctions"
import { displayCeilingAndFloorForOptions, displayInfiniteForOptions, handleProrateState, setValidityValidation } from "../../../Components/Pricings/Offers/constants/displayInfinite"
import { CycleAlignmentOption, SubscriptionEndsOnOptions, SubscriptionStartsOnOptions, TimePeriodEndOptions, TimePeriodOptions, pricingModelOptions, recurringFrequencyOptions, recurringGrantFrequencyOptions, validityEndOptions, validityStartOptions, validityTimeOptions } from "../../../Components/Pricings/Offers/constants/initialValues"
import { GET_OFFER_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { fetchResourceSuccess } from "../../resources/reducer"
import { fetchEditOfferSuccess, fetchEditOfferFailure } from "./reducer"
import moment from "moment"

export const getOffer = (setLoading, offerCode, isEdit, initialValue, setInitialValues, resourceData, serviceData, formValues, setFormValues, setStop, stop, setDisableValidityInGrantOneTime, setDisableValidityInGrantRecurring) => async (dispatch) => {
    setLoading(true)

    try {
        const response = await determineBaseUrlAndPerformApiCall(`${GET_OFFER_API}/${offerCode}`, 'GET');

        if (!response.error) {
            dispatch(fetchEditOfferSuccess(response))

            let initialValues = { ...initialValue };

            initialValues.charges = []
            initialValues.recurringCharges = []
            initialValues.grants = []
            initialValues.recurringGrants = []
            initialValues.usageRatePlan = []
            initialValues.recurringUsageRatePlan = []

            if (isEdit) {
                initialValues.offerName = response?.offerName
                initialValues.offerCode = response?.offerCode
            }
            initialValues.description = response?.description
            initialValues.offerPriority = response?.offerPriority
            initialValues.offerStartsOn = moment(response?.validity?.from);
            // initialValues.effectiveAt = moment(response?.effectiveAt);
            if (response?.validity?.to) {
                initialValues.offerEndsOn = moment.utc(response?.validity?.to);
            }

            if (response?.serviceCode) {
                if (serviceData) {
                    const matchedService = serviceData?.find(value => response?.serviceCode === value?.serviceCode);
                    if (matchedService) {
                        initialValues.serviceName = { value: matchedService.serviceCode, label: matchedService.name };
                    }
                }
            }

            initialValues.subscriptionStartsOn = SubscriptionStartsOnOptions.find(option => option.value === response.subscriptionValidity?.startTimeType)
            initialValues.subscriptionEndsOn = SubscriptionEndsOnOptions.find(option => option.value === response.subscriptionValidity?.endTimeType)
            initialValues.timePeriodStart = response.subscriptionValidity?.relativeStartTimeValue
            initialValues.timePeriod = response.subscriptionValidity?.relativeEndTimeValue
            initialValues.timePeriodOptionStart = TimePeriodOptions.find(option => parseInt(option.value) === response.subscriptionValidity?.relativeStartTimeUnit)
            initialValues.timePeriodOption = TimePeriodEndOptions.find(option => parseInt(option.value) === response.subscriptionValidity?.relativeEndTimeUnit)

            if ("Charges" in response && Array.isArray(response.Charges)) {
                response.Charges.forEach((resp, index) => {
                    let ceiling = 0;
                    let floor = 0;
                    const matchingResource = resourceData?.find(res => res.name === resp.resourceName);
                    if (matchingResource) {
                        ceiling = matchingResource.ceiling;
                        floor = matchingResource.floor;
                    }
                    if (resp.type === 1) {
                        editGrantsAndChargesFunction(initialValues.recurringCharges, resp, ceiling, floor)
                    }
                    else if (resp.type === 2) {
                        editGrantsAndChargesRecurringFunction(initialValues.recurringCharges, resp, ceiling, floor, recurringFrequencyOptions)
                    }
                })
            }

            if ("Grants" in response && Array.isArray(response.Grants)) {
                response.Grants.forEach((resp, index) => {
                    let ceiling = 0;
                    let floor = 0;
                    const matchingResource = resourceData?.find(res => res.name === resp.resourceName);
                    if (matchingResource) {
                        ceiling = matchingResource?.ceiling;
                        floor = matchingResource?.floor;
                    }
                    if (resp?.type === 1) {
                        editGrantsAndChargesFunction(initialValues?.grants, resp, ceiling, floor)
                        setValidityValidation(resourceData, { value: resp?.resourceName, label: resp?.resourceName }, setDisableValidityInGrantOneTime, index)
                    }
                    else if (resp?.type === 2) {
                        editGrantsAndChargesRecurringFunction(initialValues?.recurringGrants, resp, ceiling, floor, recurringGrantFrequencyOptions)
                        setValidityValidation(resourceData, { value: resp?.resourceName, label: resp?.resourceName }, setDisableValidityInGrantRecurring, index)
                    }
                })
            }

            if ("usageRatePlan" in response && Array.isArray(response.usageRatePlan)) {

                response.usageRatePlan.forEach((res, index) => {
                    
                    const isRecurring = res?.type == "2" || (res?.type != "1" && res?.recurringFrequency && res.recurringFrequency > 0);
                    
                    let balanceImpacts = []

                    if (res?.balanceImpact && Array.isArray(res.balanceImpact) && res.balanceImpact.length > 0) {
                        res.balanceImpact.forEach((balance) => {
                            let pricingNew = []
                            if (balance?.rateTier && Array.isArray(balance.rateTier) && balance.rateTier.length > 0 && balance.rateTier[0]?.tierType === "volume") {
                                balance.rateTier.forEach((rateTier) => {
                                    pricingNew.push({
                                        "startingUnit": rateTier?.minQuantity,
                                        "endingUnit": rateTier?.maxQuantity,
                                        "pricePerUnit": rateTier?.perUnitRate,
                                    })
                                })
                            }

                            const balanceImpact = {
                                "resourceName": { label: balance?.resourceName || '', value: balance?.resourceName || '' },
                                "uom": { label: balance?.uomName || '', value: balance?.uomName || '' },
                                "validityStart": validityStartOptions?.find(option => option?.value === balance?.validity?.startTimeType) || '',
                                "validityEnd": validityEndOptions?.find(option => option?.value === balance?.validity?.endTimeType) || '',
                                "timeUnit": validityTimeOptions?.find(option => option?.value === balance?.validity?.relativeEndTimeUnit) || '',
                                "startDateTime": balance?.validity?.from && balance.validity.from !== "0001-01-01T00:00:00Z" ? moment(balance.validity.from) : null,
                                "endDateTime": balance?.validity?.to && balance.validity.to !== "0001-01-01T00:00:00Z" ? moment(balance.validity.to) : null,
                                "timeValue": balance?.validity?.relativeEndTimeValue,
                                "pricingModel": balance?.rateTier?.[0]?.tierType ? pricingModelOptions?.find(option => option?.value === balance.rateTier[0].tierType) : null,
                                "flatRate": balance?.rateTier?.[0]?.flatRate?.toString() || '',
                                "perUnitRate": balance?.rateTier?.[0]?.perUnitRate?.toString() || '',
                                "pricingModelNew": balance?.rateTier?.[0]?.tierType === "volume" ? pricingNew : [],
                                "chargeRule": { label: balance?.chargeRule || '', value: balance?.chargeRule || '' },
                                "chargeImpact": balance?.chargeImpact?.map((item) => ({
                                    value: item,
                                    label: item
                                })) || [],
                            }
                            if (isRecurring) {
                                balanceImpact.recurringFrequency = recurringFrequencyOptions?.find(option => parseInt(option?.value) === balance?.recurringFrequency) || '';
                                balanceImpact.recurringFrequencyUnit = balance?.recurringFrequencyValue;
                                balanceImpact.cycleAlignment = CycleAlignmentOption?.find(option => option?.value === balance?.cycleAlignment) || '';
                            }

                            balanceImpacts.push(balanceImpact);
                        })
                    } else {
                        let pricingNew = []
                        if (res?.rateTier && Array.isArray(res.rateTier) && res.rateTier.length > 0 && res.rateTier[0]?.tierType === "volume") {
                            res.rateTier.forEach((rateTier) => {
                                pricingNew.push({
                                    "startingUnit": rateTier?.minQuantity,
                                    "endingUnit": rateTier?.maxQuantity,
                                    "pricePerUnit": rateTier?.perUnitRate,
                                })
                            })
                        }

                        const directImpact = {
                            "resourceName": { label: res?.resourceName || '', value: res?.resourceName || '' },
                            "validityStart": validityStartOptions?.find(option => option?.value === res?.validity?.startTimeType) || '',
                            "validityEnd": validityEndOptions?.find(option => option?.value === res?.validity?.endTimeType) || '',
                            "timeUnit": validityTimeOptions?.find(option => option?.value === res?.validity?.relativeEndTimeUnit) || '',
                            "startDateTime": res?.validity?.from && res.validity.from !== "0001-01-01T00:00:00Z" ? moment(res.validity.from) : null,
                            "endDateTime": res?.validity?.to && res.validity.to !== "0001-01-01T00:00:00Z" ? moment(res.validity.to) : null,
                            "timeValue": res?.validity?.relativeEndTimeValue,
                            "pricingModel": res?.rateTier?.[0]?.tierType ? pricingModelOptions?.find(option => option?.value === res.rateTier[0].tierType) : null,
                            "flatRate": res?.rateTier?.[0]?.flatRate?.toString() || '',
                            "perUnitRate": res?.rateTier?.[0]?.perUnitRate?.toString() || '',
                            "pricingModelNew": res?.rateTier?.[0]?.tierType === "volume" ? pricingNew : [],
                            "chargeRule": { label: res?.chargeRule || '', value: res?.chargeRule || '' },
                            "chargeImpact": res?.chargeImpact?.map((item) => ({
                                value: item,
                                label: item
                            })) || [],
                        }
                        if (isRecurring) {
                            directImpact.recurringFrequency = recurringFrequencyOptions?.find(option => parseInt(option?.value) === res?.recurringFrequency) || '';
                            directImpact.recurringFrequencyUnit = res?.recurringFrequencyValue
                            directImpact.cycleAlignment = CycleAlignmentOption?.find(option => option?.value === res?.cycleAlignment) || '';
                        }

                        balanceImpacts.push(directImpact);
                    }

                    // Handle attribute rules (if they exist in your response structure)
                    let attributeBasedDetails = []
                    if (res?.attributeRule && Array.isArray(res.attributeRule) && res.attributeRule.length > 0) {
                        res.attributeRule.forEach((rule) => {
                            let conditions = []
                            if (rule?.conditions && Array.isArray(rule.conditions) && rule.conditions.length > 0) {
                                rule.conditions.forEach((condition) => {
                                    conditions.push({
                                        "attributeName": { value: condition?.attributeName || '', label: condition?.attributeName || '' },
                                        "value": condition?.attributeValue?.toString() || '',
                                        "operator": { value: condition?.operator || '', label: condition?.operator || '' }
                                    })
                                })
                            }
                            attributeBasedDetails.push({
                                "ruleId": rule?.ruleId || '',
                                "name": rule?.ruleName || '',
                                "logicalOperator": { value: rule?.logicalOperator || 'AND', label: rule?.logicalOperator || 'AND' },
                                "conditions": conditions
                            })
                        })
                    }

                    const usageRatePlanItem = {
                        "usageId": res?.id,
                        "eventType": { label: res?.eventType || '', value: res?.eventType || '' },
                        "unitOfMeasurement": { label: res?.uomName || '', value: res?.uomName || '' },
                        "priority": res?.priority,
                        "type": res?.type?.toString() ? res?.type?.toString() : isRecurring ? "2" : "1",
                        "balanceImpacts": balanceImpacts,
                        "attributeBasedDetails": attributeBasedDetails
                    }

                    initialValues.recurringUsageRatePlan.push(usageRatePlanItem);

                    // if (isRecurring) {
                    //     initialValues.recurringUsageRatePlan.push(usageRatePlanItem);
                    // } else {
                    //     initialValues.usageRatePlan.push(usageRatePlanItem);
                    // }
                })

            }

            initialValues.categories = response?.categories?.map((item) => ({
                value: item,
                label: item
            })) || [];

            initialValues.policyName = response?.policySpecification?.[0] ?
                { value: response.policySpecification[0], label: response.policySpecification[0] } : null;

            // initialValues.aggregateVolume = {
            //     value: response?.aggregateVolume[0] || [],
            //     label: response?.aggregateVolume?.length > 0 ? response.aggregateVolume?.[0] : ''
            // };
            initialValues.aggregateVolume = response?.aggregateVolume?.map((item) => ({
                value: item,
                label: item
            })) || [];

            setFormValues({ ...initialValues });

            setTimeout(() => {
                initialValues.charges?.forEach((charge, index) => {
                    if (charge.resourceName) {
                        displayInfiniteForOptions({ value: charge.resourceName, label: charge.resourceName }, formValues?.charges?.[index], resourceData);
                        displayCeilingAndFloorForOptions({ value: charge.resourceName, label: charge.resourceName }, formValues?.charges?.[index], resourceData);
                    }
                });

                initialValues.recurringCharges?.forEach((charge, index) => {
                    if (charge.resourceName) {
                        displayInfiniteForOptions({ value: charge.resourceName, label: charge.resourceName }, formValues?.recurringCharges?.[index], resourceData);
                        displayCeilingAndFloorForOptions({ value: charge.resourceName, label: charge.resourceName }, formValues?.recurringCharges?.[index], resourceData);
                    }
                });

                initialValues.grants?.forEach((grant, index) => {
                    if (grant.resourceName) {
                        displayInfiniteForOptions({ value: grant.resourceName, label: grant.resourceName }, formValues?.grants?.[index], resourceData);
                        displayCeilingAndFloorForOptions({ value: grant.resourceName, label: grant.resourceName }, formValues?.grants?.[index], resourceData);
                    }
                });

                initialValues.recurringGrants?.forEach((grant, index) => {
                    if (grant.resourceName) {
                        displayInfiniteForOptions({ value: grant.resourceName, label: grant.resourceName }, formValues?.recurringGrants?.[index], resourceData);
                        displayCeilingAndFloorForOptions({ value: grant.resourceName, label: grant.resourceName }, formValues?.recurringGrants?.[index], resourceData);
                    }
                });
            }, 100);

            setInitialValues(initialValues);
            setStop(true);
        }
    } catch (error) {
        console.error('Error in getOffer:', error);
        dispatch(fetchEditOfferFailure(error.message));
    } finally {
        setLoading(false);
    }
}